export enum DataGrids {
	SelectionForm = 'SelectionForm',
	ProjectManagerActive = 'ProjectManagerActive',
	ProjectManagerDeleted = 'ProjectManagerDeleted',
	RunningProjects = 'RunningProjects',
	ProjectList = 'ProjectList',
	ActionManagement = 'ActionManagement',
	Announcements = 'Announcements',
	PermissionsManager = 'PermissionsManager',
	PermissionSelect = 'PermissionSelect',
	ProjectPermissions = 'ProjectPermissions',
	ProjectImportHumanResource = 'ProjectImportHumanResource',
	ProjectVersion = 'ProjectVersion',
	TaskManagementFilterLookup = 'TaskManagementFilterLookup',
	TaskManagement = 'TaskManagement',
	DataSecuritySearch = 'DataSecuritySearch',
	SQLParameters = 'SQLParameters',
	SQLColumns = 'SQLColumns',
	SQLResults = 'SQLResults',
	GPTDatasourceBody = 'GPTDatasourceBody',
	GPTDatasourceChildBody = 'GPTDatasourceChildBody',
	QueryDesignerVariableSelector = 'QueryDesignerVariableSelector',
	ImportProjectConnections = 'ImportProjectConnections',
	ImportProjectDMObjects = 'ImportProjectDMObjects',
	ImportProjectFlows = 'ImportProjectFlows',
	ImportProjectForms = 'ImportProjectForms',
	ImportProjectPats = 'ImportProjectPats',
	ImportProjectHRObjects = 'ImportProjectHRObjects',
	ImportProjectUserHRObjects = 'ImportProjectUserHRObjects',
	ImportProjectGroupHRObjects = 'ImportProjectGroupHRObjects',
	ImportProjectDepartmentHRObjects = 'ImportProjectDepartmentHRObjects',
	ImportProjectPositionHRObjects = 'ImportProjectPositionHRObjects',
	ImportProjectProfessionHRObjects = 'ImportProjectProfessionHRObjects',
	ImportProjectPropertyTypeHRObjects = 'ImportProjectPropertyTypeHRObjects',
	ImportProjectManagerKeysHRObjects = 'ImportProjectManagerKeysHRObjects',
	ImportProjectConnectionSelect = 'ImportProjectConnectionSelect',
	ImportProjectFormModal = 'ImportProjectFormModal',
	HRManagers = 'HRManagers',
	MLEditor = 'MLEditor',
	HRUsers = 'HRUsers',
	HRPositions = 'HRPositions',
	HRDepartments = 'HRDepartments',
	HRCompanies = 'HRCompanies',
	HRProfessions = 'HRProfessions',
	HRUserGroups = 'HRUserGroups',
	HRCompanyAdmins = 'HRCompanyAdmins',
	HRManagerKeys = 'HRManagerKeys',
	HROvertimes = 'HROvertimes',
	HRShifts = 'HRShifts',
	HRSalaries = 'HRSalaries',
	HRUserMaintenances = 'HRUserMaintenances',
	HRPositionMaitenances = 'HRPositionMaitenances',
	HRDepartmentMaintenances = 'HRDepartmentMaintenances',
	HRProfessionMaintenances = 'HRProfessionMaintenances',
	HRProperties = 'HRProperties',
	HRUserProperties = 'HRUserProperties',
	HRPositionProperties = 'HRPositionProperties',
	HRProfessionProperties = 'HRProfessionProperties',
	HRDepartmentProperties = 'HRDepartmentProperties',
	HRGroupProperties = 'HRGroupProperties',
	HRPositionFormUser = 'HRPositionFormUser',
	HRDepartmentFormManager = 'HRDepartmentFormManager',
	HRDepartmentFormManagerDepartment = 'HRDepartmentFormManagerDepartment',
	HRUserMaintenanceFormOld = 'HRUserMaintenanceFormOld',
	HRUserMaintenanceFormReplace = 'HRUserMaintenanceFormReplace',
	HRPositionMaintenanceFormOld = 'HRPositionMaintenanceFormOld',
	HRPositionMaintenanceFormReplace = 'HRPositionMaintenanceFormReplace',
	HRDepartmentMaintenanceFormOld = 'HRDepartmentMaintenanceFormOld',
	HRDepartmentMaintenanceFormReplace = 'HRDepartmentMaintenanceFormReplace',
	HRProfessionMaintenanceFormOld = 'HRProfessionMaintenanceFormOld',
	HRProfessionMaintenanceFormReplace = 'HRProfessionMaintenanceFormReplace',
	HRSalaryFormUserId = 'HRSalaryFormUserId',
	HRGroupMembers = 'HRGroupMembers',
	HRPropertiesListType = 'HRPropertiesListType',
	HRUserFormProfession = 'HRUserFormProfession',
	HRUserFormShift = 'HRUserFormShift',
	HRUserFormDepartment = 'HRUserFormDepartment',
	HRUserManagers = 'HRUserManagers',
	HRUserManagerUser = 'HRUserManagerUser',
	FlowManager = 'FlowManager',
	FlowObjects = 'FlowObjects',
	FlowFilterModal = 'FlowFilterModal',
	FlowDesigner = 'FlowDesigner',
	FormStatusList = 'FormStatusList',
	FormPublicFieldPool = 'FormPublicFieldPool',
	FormPublicFields = 'FormPublicFields',
	SummaryTypes = 'SummaryTypes',
	PagingSizes = 'PagingSizes',
	HiddenRowValues = 'HiddenRowValues',
	ValueMatchers = 'ValueMatchers',
	IconMatchers = 'IconMatchers',
	DMViewerContentList = 'DMViewerContentList',
	DelegationList = 'DelegationList',
	AccessToken = 'AccessToken',
	WFProcessList = 'WFProcessList',
	DMViewerRelationList = 'DMViewerRelationList',
	LookupGrid = 'LookupGrid',
	LogViewer = 'LogViewer',
	ActionViewerRelations = 'ActionViewerRelations',
	DataSecurityTypes = 'DataSecurityTypes',
	LicenceUsers = 'LicenceUsers',
	ConnectionHeaders = 'ConnectionHeaders',
	SubReasonLookup = 'SubReasonLookup',
	MetaDataFields = 'MetaDataFields',
	DMFavorites = 'DMFavorites',
	DMRecent = 'DMRecent',
	DMRepositories = 'DMRepositories',
	DMTrash = 'DMTrash',
	DMExplorer = 'DMExplorer',
	DMIndexSettings = 'DMIndexSettings',
	DMSearch = 'DMSearch',
	FlowSteps = 'FlowSteps',
	ProcessDetails = 'ProcessDetails',
	CaptureIndexField = 'CaptureIndexField',
	CaptureIndexProfile = 'CaptureIndexProfile',
	SecurityMembers = 'SecurityMembers ',
	AnnouncementRoleSelection = 'AnnouncementRoleSelection'
}
